module.exports = __webpack_public_path__ + "img/something-went-wrong.7ccdbeb5.svg";